export default __webpack_public_path__ + "static/media/step2-challenge-gif.949cb723.gif";